// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__27CvM","insightsList":"newBusinessInsightsMenu_insightsList__12j8L","active":"newBusinessInsightsMenu_active__1CKKi"};